/*Modified by Aritra Basak
 */
import * as React from "react";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { asyncPost } from "../../common/utils";
import { URI } from "../../constants/index";
import { CircularProgress } from "@material-ui/core";
import "../../assets/styles/VerifyAbha.css";
import {
  RESEND_OTP_TIMEOUT,
  RESEND_OTP_CHANCE,
} from "../../constants/dataconstants";

const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "white !important",
  },
  stepper: {
    "& .MuiStepIcon-active": { color: global.secondaryColour },
    "& .MuiStepIcon-completed": { color: global.secondaryColour },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ccc" },
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: theme.spacing(5),
  },
  button: {
    margin: theme.spacing(1),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

export default function VerifyAbha() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [healthId, setHealthId] = React.useState("");
  const [authMode, setAuthMode] = React.useState("");
  const [txnId, setTxnId] = React.useState("");
  const [authCode, setAuthCode] = React.useState("");
  const [xToken, setXToken] = React.useState("");
  const [profile, setProfile] = React.useState(new Set());
  const [showLoader, setShowLoader] = React.useState(false);
  const [profileImageRes, setProfileImageRes] = React.useState();
  const [modalData, setModalData] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [buttonText, setButtonText] = React.useState("RESEND OTP");
  const [resendOtpChance, setResendOtpChance] = React.useState(0);
  const [intervalId, setIntervalId] = React.useState(null);

  const handleAuthCode = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAuthCode(value);
    } else {
      setAuthCode((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setAuthCode("");
    }
    if (activeStep === 2) {
      setActiveStep(0);
      resetHooks();
    }
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleModalOpen = () => {
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  //To enable the Resend OTP button after a certain time {RESEND_OTP_TIMEOUT}
  const resendOtpButtontext = () => {
    let count = parseInt(resendOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0 && count < RESEND_OTP_CHANCE) {
      const id = setInterval(() => {
        setButtonText("RESEND OTP AFTER: " + i);
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setResendOtpChance(count.toString());
          count > RESEND_OTP_CHANCE
            ? setButtonText("CANNOT USE RESEND OTP")
            : setButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
    if (count >= RESEND_OTP_CHANCE) {
      setButtonText("CANNOT USE RESEND OTP");
    }
  };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne();
    } else if (activeStep == 1) {
      return populateScreenFlowTwo();
    } else if (activeStep == 2) {
      return populateScreenFlowThree();
    } else if (activeStep == 3) {
      return populateScreenFlowFour();
    }
  };
  //Get Otp
  const onGetOtp = async () => {
    clearInterval(intervalId); //Clearing the resendOTP button timer interval at the start, so that if someone exit the process before confirming the OTP and restart the process, correct OTP will be displayed.
    if (healthId.trim() == "") {
      setModalData("Kindly Enter your ABHA Address or ABHA Number.");
      handleModalOpen();
      return false;
    }
    if (authMode.trim() == "") {
      setModalData("Kindly Choose the Authentication Mode.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      healthId: healthId,
      authMode: authMode,
    };
    // debugger;
    const res = await asyncPost(URI.authInit, __oo, true, true, global.token);
    if (res && res.status == 2000) {
      setTxnId(res.data.txnId); // transaction ID
      handleNext();
      setModalData(
        authMode === "AADHAAR_OTP"
          ? "OTP has been sent to the ABHA registered Aadhaar Linked Mobile Number."
          : "OTP has been sent to the ABHA registered Mobile Number."
      );
      handleModalOpen();
      setShowLoader(false);
      resendOtpButtontext();
    } else {
      setShowLoader(false);
      // debugger;
      if (
        String(res.status).includes("5001") &&
        res.ndhmErrorMsg &&
        Array.isArray(res.ndhmErrorMsg.details) &&
        res.ndhmErrorMsg.details.length > 0 &&
        res.ndhmErrorMsg.details[0].message.includes("30 minutes")
      ) {
        setModalData(
          "Code: " +
            res.ndhmErrorMsg.details[0].code +
            "\n" +
            "Message: " +
            res.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      } else if (
        res.ndhmErrorMsg &&
        res.ndhmErrorMsg.hasOwnProperty("message")
      ) {
        setModalData(res.ndhmErrorMsg.message);
        handleModalOpen();
        return false;
      } else if (
        res.ndhmErrorMsg &&
        Array.isArray(res.ndhmErrorMsg.details) &&
        res.ndhmErrorMsg.details.length > 0
      ) {
        setModalData(
          "Message from ABDM : Unable to send OTP\n" +
            res.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      } else {
        setModalData("An unknown error occurred.");
        handleModalOpen();
        return false;
      }
    }
  };
  //To resend OTP for initiating authentication.
  const resendConfirmOtp = async () => {
    setShowLoader(true);
    var count = parseInt(resendOtpChance);
    count++;
    setResendOtpChance(count);
    const __oo = {
      healthId: healthId,
      authMode: authMode,
    };
    // debugger;
    const res = await asyncPost(URI.authInit, __oo, true, true, global.token);
    if (res && res.status == 2000) {
      setTxnId(res.data.txnId); //transaction ID
      setModalData(
        authMode === "AADHAAR_OTP"
          ? "OTP has been send to the ABHA registered Aadhaar Linked Mobile Number."
          : "OTP has been send to the ABHA registered Mobile Number."
      );
      handleModalOpen();
      resendOtpButtontext();
      setShowLoader(false);
      return false;
    } else {
      setShowLoader(false);
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setModalData(
          "Message from ABDM : Unable to send OTP\n" +
            res.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      }
    }
  };

  // To verify the generated OTP in the previous step and proceed to next page
  const onConfirm = async () => {
    if (authCode.trim() == "") {
      setModalData("Kindly Enter your OTP first.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      txnId: txnId, //transaction ID
      otp: authCode,
    };
    // debugger;
    const res = await asyncPost(
      authMode === "MOBILE_OTP"
        ? URI.authConfirmWithMobileOtp
        : URI.authConfirmWithAadhaarOtp,
      __oo,
      true,
      true,
      global.token
    );
    if (res && res.status == 2000) {
      //debugger;
      setXToken(res.data.token);
      const __oo1 = {
        token: res.data.token,
      };
      // debugger;
      const res1 = await asyncPost(
        URI.getProfile,
        __oo1,
        true,
        true,
        global.token
      );
      if (res1 && res1.status == 2000) {
        //debugger;
        global.profile = res1.data;
        console.log("data " + res1.data);
        setProfile(res1.data);
        setShowLoader(false);
        setModalData("Your ABHA profile has been verified successfully.");
        handleModalOpen();
        handleNext();
        clearInterval(intervalId);
      } else {
        setShowLoader(false);
        setModalData(
          "Message from ABDM : Unable to fetch profile.\n" +
            res1.ndhmErrorMsg.message +
            "\n" +
            res1.ndhmErrorMsg.details[0].message
        );
        handleModalOpen();
        return false;
      }
    } else {
      setShowLoader(false);
      if (
        res.status === 5001 &&
        res.hasOwnProperty("ndhmErrorMsg") &&
        res.ndhmErrorMsg.code === "HIS-422"
      ) {
        setModalData(res.ndhmErrorMsg.details[0].message);
        handleModalOpen();
        return false;
      }

      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      }
      setModalData("Message from ABDM : Unable to confirm the authentication.");
      handleModalOpen();
      return false;
    }
  };

  const getHealthCard = async () => {
    setShowLoader(true);
    const __oo = {
      txnId: txnId,
      token: xToken,
    };
    // debugger;
    const res = await asyncPost(URI.getPngCard, __oo, true, true, global.token);
    console.log("Health Card Response >>> " + JSON.stringify(res));
    if (res.status === 2000) {
      //debugger;
      setProfileImageRes(res.data);
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      }
      setModalData("Message from ABDM : Unable to confirm the authentication.");
      handleModalOpen();
      return false;
    }
  };
  //to post the fetched data to the parent web interface.
  const postMessageToParent = async () => {
    const day =
      global.profile.dayOfBirth !== null && global.profile.dayOfBirth !== ""
        ? global.profile.dayOfBirth.trim().length === 1
          ? "0" + global.profile.dayOfBirth
          : global.profile.dayOfBirth
        : "01";

    const month =
      global.profile.monthOfBirth !== null && global.profile.monthOfBirth !== ""
        ? global.profile.monthOfBirth.trim().length === 1
          ? "0" + global.profile.monthOfBirth
          : global.profile.monthOfBirth
        : "01";
    const __oo = {
      name: global.profile.name,
      healthId: global.profile.healthId,
      healthIdNumber: global.profile.healthIdNumber,
      gender: global.profile.gender,
      mobile: global.profile.mobile,

      dob: day + "/" + month + "/" + global.profile.yearOfBirth,
      isNew: global.profile.new === "false" ? false : true,
      yearOfBirth: global.profile.yearOfBirth,
      pngCard: profileImageRes,
      kycPhoto: "",
      address:
        global.profile.address === undefined ? "" : global.profile.address,
      districtCode:
        global.profile.districtCode === undefined
          ? ""
          : global.profile.districtCode,
      stateCode:
        global.profile.stateCode === undefined ? "" : global.profile.stateCode,
      pinCode:
        global.profile.pinCode === undefined ? "" : global.profile.pinCode,
      aadhaarNumber: "",
    };
    console.log(__oo);
    window.parent.postMessage(JSON.stringify(__oo), "*");
  };

  //This Event is trigerred from the parent web UI.
  window.addEventListener("message", function (event) {
    if (event.data === "closeWindow") {
      postMessageToParent();
    }
  });

  const backToHome = async () => {
    postMessageToParent();
    setActiveStep(0);
    resetHooks();
  };

  const resetHooks = () => {
    setHealthId("");
    setAuthCode("");
    setAuthMode("");
    setResendOtpChance(0);
    clearInterval(intervalId);
  };

  //For downloading the card
  const downloadPng = async () => {
    // window.location.href = 'data:application/octet-stream;base64,' + profileImageRes;
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + profileImageRes; //Image Base64 Goes here
    a.download = "VerifiedHealthCard.png"; //File name Here
    a.click(); //Downloaded file
  };

  //Full Authentication form for generating OTP
  const populateScreenFlowOne = () => {
    return (
      <div>
        <form className={classes.form} noValidate>
          <Grid
            container
            direction={"row"}
            spacing={5}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <TextField
                variant="standard"
                margin="normal"
                label="Enter ABHA Address/Number"
                required
                id="healthId"
                value={healthId}
                name="healthId"
                style={{ marginTop: 12 }}
                InputLabelProps={{
                  style: { marginTop: -24 }, // Adjust the negative margin value as needed
                }}
                onChange={(e) => setHealthId(e.target.value)}
              />
            </Grid>
            <Grid item>
              <InputLabel id="loginAsLabel">Authentication Mode</InputLabel>
              <Select
                fullWidth
                labelId="authMode"
                id="authMode"
                className={classes.selectEmpty}
                onChange={(e) => {
                  setAuthMode(e.target.value);
                }}
              >
                <MenuItem value="">
                  <strong>None</strong>
                </MenuItem>
                <MenuItem value={"AADHAAR_OTP"}>
                  <strong>AADHAAR OTP</strong>
                </MenuItem>
                <MenuItem value={"MOBILE_OTP"}>
                  <strong>MOBILE OTP</strong>
                </MenuItem>
              </Select>
            </Grid>
            <Grid item>
              <Button
                type="button"
                fullWidth
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                }}
                className={classes.submit}
                onClick={() => onGetOtp()}
              >
                Get OTP
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  };

  const populateScreenFlowTwo = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              variant="standard"
              label="OTP"
              required
              id="authCode"
              value={authCode}
              autoComplete="off"
              inputProps={{ maxLength: 6 }}
              onChange={(e) => handleAuthCode(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => onConfirm()}
            >
              Confirm
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                backgroundColor:
                  buttonText === "RESEND OTP" ? global.secondaryColour : "#ccc",
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => resendConfirmOtp()}
              disabled={buttonText === "RESEND OTP" ? false : true}
            >
              {buttonText}
            </Button>
          </Grid>
          <Grid item>
            <item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {resendOtpChance === 3 ? (
                ""
              ) : (
                <span>
                  You can resend OTP{" "}
                  <span style={{ color: "#D20062" }}>
                    {resendOtpChance > 0
                      ? parseInt(RESEND_OTP_CHANCE) -
                        parseInt(resendOtpChance) +
                        1
                      : 2}
                  </span>{" "}
                  more times
                </span>
              )}
            </item>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowThree = () => {
    //debugger;
    // global.profile = PROFILE;
    const profileImage =
      "data:image/png;base64, " + global.profile.profilePhoto;
    return (
      <Table size="big">
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Number</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {global.profile.healthIdNumber}
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Address</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {global.profile.healthId}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Name</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {global.profile.name}
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Gender</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {global.profile.gender == "M" ? "Male" : "Female"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Mobile</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {global.profile.mobile}
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Date of Birth</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {global.profile.dayOfBirth === null &&
              global.profile.monthOfBirth === null
                ? global.profile.yearOfBirth
                : global.profile.dayOfBirth +
                  "/" +
                  global.profile.monthOfBirth +
                  "/" +
                  global.profile.yearOfBirth}
            </TableCell>
          </TableRow>
          {global.profile.districtName != null &&
          global.profile.stateName != null ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>State</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {global.profile.stateName}
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>District</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {global.profile.districtName}
              </TableCell>
            </TableRow>
          ) : (
            ""
          )}
          {global.profile.pincode != null && global.profile.address != null ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Address</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {global.profile.address}
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Pincode</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {global.profile.pincode}
              </TableCell>
            </TableRow>
          ) : (
            ""
          )}
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <img src={profileImage} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                }}
                onClick={() => getHealthCard()}
              >
                View ABHA Card
              </Button>
              <Button
                variant="contained"
                className="mx-2 "
                color="default"
                style={{ color: "#f53169d9" }}
                onClick={() => backToHome()}
              >
                Back To Home
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const populateScreenFlowFour = () => {
    const profileImageI = "data:image/png;base64, " + profileImageRes;
    const onButtonClick = () => {
      // using Java Script method to get PDF file
      fetch("profileImageI").then((response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "profileImageI";
          alink.click();
        });
      });
    };
    return (
      <div className="imgcontainer">
        <div className="printablediv">
          <img src={profileImageI} />
        </div>

        <div style={{ textAlign: "center" }} className="button_container my-2">
          <Button
            variant="contained"
            className="mx-2"
            style={{
              backgroundColor: global.secondaryColour,
              color: "#fff",
            }}
            onClick={() => downloadPng()}
          >
            Download ABHA Card
          </Button>
          <Button
            variant="contained"
            className="mx-2 "
            color="default"
            style={{ color: "#f53169d9" }}
            onClick={() => backToHome()}
          >
            Back To Home
          </Button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "10px" }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
            {/* {generateScreen()} */}
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            >
              <Button
                style={
                  activeStep === 0 || activeStep === 3
                    ? { color: "#ccc" }
                    : { color: "#f53169d9" }
                }
                onClick={() => handleBack()}
                sx={{ mr: 1 }}
                disabled={activeStep === 0 || activeStep === 3 ? true : false}
              >
                {" "}
                Back
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={() => handleModalClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalState}>
          <Box
            className={classes.modalStyle}
            style={{
              background: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 10,
              padding: "15px",
            }}
          >
            <h5 id="transition-modal-title">Information</h5>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <pre>{modalData}</pre>
            </Typography>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => handleModalClose()}
            >
              OK
            </Button>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
